<script setup lang="ts">
import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import { useRouter } from 'vue-router';
import logo from '@/assets/icons/icon-air-luggage-en.svg';

const emit = defineEmits<{
    menuToggle: [];
}>();

const router = useRouter();
const { mobile } = useDisplay();

const headerHeight = computed(() => {
    return mobile.value ? 56 : 64;
});

const logoHeight = computed(() => {
    return mobile.value ? 34 : 44;
});

const toggleMenu = () => {
    emit('menuToggle');
};

const navigateToTop = () => {
    router.push({ name: 'admin-top' });
};
</script>

<template>
    <v-app-bar color="bg" elevation="0" :height="headerHeight" app flat>
        <v-container fluid class="d-flex align-center pa-2">
            <!-- Logo/Brand -->
            <div class="grow-0 cursor-pointer" @click="navigateToTop">
                <img :src="logo" alt="Air Luggage" :height="logoHeight" />
            </div>
            <v-spacer />

            <span id="header-title-slot"></span>

            <v-spacer />

            <v-btn icon="mdi-menu" variant="text" size="large" @click="toggleMenu" />
        </v-container>
    </v-app-bar>
</template>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}

#header-title-slot :deep(.header-title) {
    font-size: 1.25rem;
    white-space: nowrap;
    margin: 0;
    font-weight: 400;
}

@media (max-width: 599px) {
    #header-title-slot :deep(.header-title) {
        font-size: 1rem;
    }
}
</style>
